import { Customer } from '../../models';

export interface CustomerState {
  selectedCustomer?: Customer;
  doneLoading: boolean;
}

export const featureName = 'customer';
